import Toast from 'react-native-toast-message';
import { bridge } from '../../utils';
import { Flex, Typography } from '@banhala/ui-kit';
import { HTMLText } from '../../component/HTMLText';

export const toast = ({
  folderName,
  folderSno,
  screen,
  bottomOffset,
  loggingAnalytics,
  openDeeplink,
  snackbar,
}: {
  screen: string;
  folderName: string;
  folderSno: number;
  bottomOffset?: number;
  loggingAnalytics?: Record<string, unknown>;
  openDeeplink: (link: string) => void;
  snackbar?: { message: string; deeplink: string } | null;
}) => {
  const message =
    snackbar?.message ?? `상품을 <b>${folderName}</b>에 상품을 찜했어요`;
  const deeplink = snackbar?.deeplink ?? `ably://like/folders/${folderSno}`;

  Toast.show({
    type: 'success',
    bottomOffset,
    props: {
      customText: (
        <Flex.Row
          height={48}
          width={'100%'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Flex flex={1}>
            <HTMLText
              type="body2"
              color="content_always_white"
              numberOfLines={1}
            >
              {message}
            </HTMLText>
          </Flex>
          <Flex.Column
            onPress={() => {}}
            onPressIn={() => {
              bridge.logAnalyticsEvent({
                name: 'CLICK_FOLDER',
                analytics: {
                  SCREEN: screen,
                  FOLDER_SNO: folderSno,
                  LANDING_FROM: 'TOAST',
                  ...loggingAnalytics,
                },
              });
              openDeeplink(deeplink);
            }}
            hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
          >
            <Typography color={'content_blue_primary'}>보러가기</Typography>
          </Flex.Column>
        </Flex.Row>
      ),
    },
    position: 'bottom',
  });
};
